import React from "react";
import { Link } from "react-router-dom";
import panda from "../../../../../../../assets/img/sad-panda.svg";

export default function LoggedOutFooter(props) {
  // const links = [
  // ];
  // for (let i = 0; i < props.courses.length; i++) {
  //   links.push({title: props.courses[i].courseUrl, url: `/course/${props.courses[i].courseUrl}`})
  // }

  return (
    <div>
      <footer id="footer">
        <div className="wave"></div>
        <div className="top_footer text-center">
          <div className="container">
            <div className="row">
              <div className="col col-6 fooer-content flex flex-col items-center pb-8">
                <img className="max-w-[200px]" alt="logo" src={panda} />
                {/* <NewsLetterForm title={"Subscribe Our Newsletter"} className={'landing-newsletter'}/> */}
                {/* <ul className="list_none footer_social">
                  <li>
                    <a
                      href="https://www.facebook.com/duomlyapp/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Facebook"
                    >
                      <i className="fi flaticon-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://twitter.com/duomly"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Twitter"
                    >
                      <i className="fi flaticon-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://medium.com/duomly-blockchain-online-courses"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Medium"
                    >
                      <i className="fi flaticon-medium"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/duomly_programming_courses/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Instagram"
                    >
                      <i className="fi flaticon-logo"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCPQy6LADYYamG_4a6TSIelQ?subscribe=1"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Subscribe us on Youtube"
                    >
                      <i className="fi flaticon-video"></i>
                    </a>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
          <div className="rounded_shape light_rounded_shape1"></div>
        </div>
        <div className="bottom_footer">
          <div className="container">
            <div className="row">
              <div className="col col-6">
                <p className="copyright">
                  Duomly.com Copyright © {String(new Date().getFullYear())} All
                  Rights Reserved.
                </p>
              </div>
              <div className="col col-6">
                <ul className="list_none footer_menu">
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy">Privacy Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className="links-courses">
                {links.map(link=><Link key={shortid.generate()} to={link.url}>{link.title}</Link>)}
              </div> */}
          </div>
        </div>
      </footer>
    </div>
  );
}
